import React, { useEffect, useState } from 'react';
import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    Row,
    Space,
    Switch,
    Upload,
    Select,
    Table,
} from 'antd';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import {
    SettingsClientAnalyticsApi,
    SettingsClientWorkSpaceAnalyticsApi,
} from '../../../../../Redux/Apis/user/ApiConfig';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
const { Option } = Select;
export default function EditAccount({
    onClose,
    open,
    editId,
    state,
    getData,
    data,
}) {
    let dispatch = useDispatch();
    const [form] = Form.useForm();
    let SideClose = '/assets/ModalClose.svg';
    const [user, setUser] = useState();
    const [mockData, setMockData] = useState(null);
    const [workspace, setWorkspace] = useState();
    const [selectedWorkspaces, setSelectedWorkspaces] = useState();
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    useEffect(() => {
        // const data = JSON.parse(localStorage.getItem(`account${state}`));
        // const foundItem = data.find((item, index) => index === editId);
        fetchDropdownData();
        workspaceChange(data.client_id);
        dispatch(workspaces_List_ActionHandler('', '', ''));
    }, []);
    useEffect(() => {
        if (data?.workspace) {
            setSelectedWorkspaces(
                data.workspace.map((item) => ({
                    workspace_id: item.workspace_id,
                    name: item.workspace_name,
                }))
            );
        }
    }, [data]);
    const fetchDropdownData = async () => {
        try {
            const { data } = await SettingsClientAnalyticsApi();
            setUser(data?.data);
        } catch (err) {}
    };
    const workspaceChange = async (id) => {
        try {
            const { data } = await SettingsClientWorkSpaceAnalyticsApi(id);
            setWorkspace(data?.data);
        } catch (err) {
            console.log(
                'error occured while fetching userlist and workspace rule list',
                err
            );
        }
    };
    const handleFormSubmit = (values) => {
        console.log(editId, 'editId');
        const existingData = localStorage.getItem(`account${editId}`);
        let newData = existingData ? JSON.parse(existingData) : [];
        console.log(newData, 'newData');
        const index = newData.findIndex(
            (item) => item.client_id === values.client_id
        );
        if (index !== -1) {
            // Update the item
            // newData[index] = { ...newData[index], ...values };
            const { client_id, workspace_ids } = values;
            const clientData = user.find((item) => item.id === client_id);
            const workspaceData = workspace_ids?.map((id) => {
                const workspaceItem = workspace.find((item) => item.id === id);
                return {
                    workspace_id: id,
                    workspace_name: workspaceItem ? workspaceItem.name : '', // Default to empty string if workspaceItem is not found
                };
            });
            const dataToStore = {
                client_id: clientData.id,
                name: clientData.name,
                workspace: workspaceData,
            };
            newData[index] = { ...newData[index], ...dataToStore };
            const newDataJson = JSON.stringify(newData);
            localStorage.setItem(`account${editId}`, newDataJson);
            Swal.fire({
                icon: 'success',
                title: 'Account Successfully Edited!',
                showConfirmButton: false,
                confirmButtonColor: 'rgb(231,52,70)',
                timer: 1500,
            });

            getData();
            onClose();
        } else {
            // Handle case where item to edit is not found
            console.error('Item not found for editing');
        }
    };
    return (
        <div>
            <Drawer
                placement='right'
                closable={false}
                key='right'
                onClose={onClose}
                open={open}
                width={'40%'}>
                <img
                    className='edit-own-data-output-side-close'
                    src={SideClose}
                    alt=''
                    onClick={onClose}
                />
                <Form form={form} onFinish={handleFormSubmit}>
                    <h3>Edit Account for Visibility</h3>
                    <Row gutter={24}>
                        <Col span={24}>
                            <label>
                                Select Account{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <Form.Item
                                name='client_id'
                                initialValue={data?.client_id}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please choose the account',
                                    },
                                ]}>
                                {data && (
                                    <Select
                                        name='client_id'
                                        placeholder='Account Name'
                                        showSearch
                                        optionFilterProp='label'
                                        disabled={true}>
                                        {user &&
                                            user?.map((item) => (
                                                <Option
                                                    key={item.id}
                                                    value={item.id}
                                                    label={item.name}>
                                                    {item.name}
                                                </Option>
                                            ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <label>
                                Select Workspace{' '}
                                <span style={{ color: 'red' }}>*</span>
                            </label>
                            <Form.Item
                                name='workspace_ids'
                                initialValue={data?.workspace?.map(
                                    (item) => item.workspace_id
                                )}
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: 'Please choose the workspace',
                                //     },
                                // ]}
                            >
                                {workspace && data && user && (
                                    // <Select
                                    //     name='workspace_ids'
                                    //     mode='multiple'
                                    //     placeholder='Add workspace here'
                                    // >
                                    //     {workspace &&
                                    //         workspace.map((data) => (
                                    //             <Option
                                    //                 key={data.id}
                                    //                 value={data.id}
                                    //                 label={data.name}
                                    //             >
                                    //                 {data.name}
                                    //             </Option>
                                    //         ))}
                                    // </Select>

                                    <Select
                                        name='workspace_ids'
                                        mode='multiple'
                                        placeholder='Add workspace here'
                                        showSearch
                                        optionFilterProp='label'
                                        initialValue={data?.workspace_id?.map(
                                            (item) => item.workspace_id
                                        )}>
                                        {workspace &&
                                            workspace?.map((item) => (
                                                <Option
                                                    key={item.id}
                                                    value={item.id}
                                                    label={item.name}>
                                                    {item.name}
                                                </Option>
                                            ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <div className='add-worksapce-member'>
                        <div
                            className='create-workspace-btn'
                            // onClick={handleCreatefolder}
                        >
                            <Button htmlType='submit' className='main-api'>
                                Save
                            </Button>
                        </div>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
}
